import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [dark, setDark] = useState(false);

  return (
    <div
      style={{
        ...styles.container,
        background: dark ? "#1e1e2f" : "#f4f6f9",
        color: dark ? "#fff" : "#000"
      }}
    >
      <div style={{ ...styles.sidebar, width: collapsed ? 70 : 220 }}>
        <Sidebar collapsed={collapsed} />
      </div>

      <div style={styles.main}>
        <Header
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          dark={dark}
          setDark={setDark}
        />

        <div style={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;

const styles = {
  container: { display: "flex", minHeight: "100vh" },
  sidebar: { transition: "0.3s", borderRight: "1px solid #ddd" },
  main: { flex: 1, display: "flex", flexDirection: "column" },
  content: { padding: 20 }
};